var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83656 0H38.1634C43.0437 0 47 3.95636 47 8.83664V28.0716C47 32.9519 43.0438 36.9082 38.1634 36.9082H25.7679C25.6678 36.9082 25.5722 36.9495 25.5037 37.0224L15.5486 47.6074C14.7801 48.4247 13.4079 47.8808 13.4079 46.759V37.2708C13.4079 37.0705 13.2456 36.9082 13.0454 36.9082H8.83656C3.95633 36.9082 0 32.952 0 28.0716V8.83664C0 3.95636 3.95614 0 8.83656 0ZM24.9762 12.3858C26.8118 10.5381 29.7878 10.5381 31.6234 12.3858C33.4589 14.2337 33.4589 17.2295 31.6233 19.0774L23.94 26.8134C23.6928 27.0622 23.2919 27.0622 23.0447 26.8134L15.3766 19.0941C13.5411 17.2462 13.5411 14.2503 15.3766 12.4025C17.2123 10.5547 20.1882 10.5547 22.0238 12.4025L23.0441 13.4296C23.2913 13.6785 23.6922 13.6785 23.9394 13.4296L24.9762 12.3858Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.d9f43017.svg";
export { ForwardRef as ReactComponent };